import contracts from './contracts'
import orders from './orders'
import billingAndAccounting from './billingAndAccounting'
import dashboard from './dashboard'
import products from './products'
import tasks from './tasks'
import users from './users'
import settings from './settings'
import tools from './tools'
import customers from './customers'
import administration from './administration'

export default ($page) => {
    return [
        {
            route: '',
            label: 'messages.sitemap.dashboard.dashboard',
            icon: 'view-dashboard-outline',
            sidebarItemName: 'dashboard',
            isStandaloneItem: true,
            children: dashboard,
            id: 'dashboard'
        },
        {
            route: '',
            label: 'messages.sitemap.customers.customers',
            icon: 'account-outline',
            sidebarItemName: 'customer',
            id: 'customers',
            children: customers,
            permissions: [
                'customer.view',
                'customer.create',
                'customer.incidents_view',
                'price.edit'
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.contracts.contracts',
            icon: 'file-document-edit-outline',
            sidebarItemName: 'contract',
            id: 'contracts',
            children: contracts($page),
            permissions: [
                'contract.contracts',
                'contract.pending',
                'contract.manage_terminations',
                'contract.fulfillment',
                'contract.duplicates',
                'contract.transfer.cancel',
                'contract.pricings',
                'contracts.contract',
                'contract.upload'
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.orders.orders',
            icon: 'cart-variant',
            sidebarItemName: 'order',
            id: 'orders',
            children: orders($page),
            permissions: ['order.view']
        },
        {
            route: '',
            label: 'messages.sitemap.products.products',
            icon: 'view-grid-outline',
            sidebarItemName: 'product',
            id: 'products',
            children: products($page),
            permissions: [
                'product.view',
                'contract.edit',
                'product.manage_packages',
                'product.termination_rules.edit',
                'product.termination_rules.view',
                'products.partner_api',
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.billing_and_accounting.billing_and_accounting',
            icon: 'cart-variant',
            sidebarItemName: 'billingAndAccounting',
            id: 'billing-and-accounting',
            children: billingAndAccounting($page),
            permissions: [
                'invoice.manage',
                'dunning.manage',
                'payment.sepa',
                'dunning.collection',
                'contract.partners',
                'contract.distributors',
                'payment.credit_card',
                'providerbox.import',
                'billing_and_accounting.manual_invoice_uploads',
                'billing_and_accounting.customer_balances'
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.tools.tools',
            icon: 'toolbox-outline',
            sidebarItemName: 'tools',
            id: 'tools',
            children: tools($page),
            permissions: [
                'tool.activity_log',
                'tool.emails',
                'tool.documents',
                'tool.emails_edit',
                'communication.view'
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.tasks.tasks',
            icon: 'clipboard-list-outline',
            sidebarItemName: 'task',
            id: 'tasks',
            children: tasks,
            permissions: ['task.manage']
        },
        {
            route: '',
            label: 'messages.sitemap.settings.settings',
            icon: 'cog-outline',
            sidebarItemName: 'settings',
            id: 'settings',
            children: settings($page),
            permissions: [
                'setting.general',
                'setting.brands',
                'setting.customer_segments',
                'settings.lov_countries',
                'setting.terms',
                'setting.affiliate',
                'setting.cloudpit',
                'setting.hosting',
                'setting.ms365',
                'setting.whmcs',
                'setting.tax_rules',
                'setting.tax_exemptions',
                'setting.revenue_cost_centers',
                'setting.finance_system',
                'setting.reminder',
                'setting.invoice_pdf',
                'setting.dunning_pdf',
                'fulfillment.view',
                'dns_templates.view',
                'settings.dns',
                'setting.bank_accounts',
                'setting.credit_note_types',
                'setting.tax_rules_credit_note',
                'setting.osa',
                'setting.jira',
                'setting.currency_rates_api_settings',
                'setting.adyen',
                'setting.sendinblue',
                'setting.dwh',
                'setting.transfer',
                'setting.domain_tool',
                'setting.providerbox',
                'setting.permissions',
                'setting.permissions.edit',
                'setting.permission_set_limits',
                'setting.zendesk',
                'setting.translations.view',
                'setting.translations.edit',
                'setting.postal_delivery',
                'setting.fulfillment.domain_config',
                'setting.visma',
                'settings.my_antagonist',
                'setting.s3_setting',
                'setting.invoice_delivery',
                'setting.lov_incidents',
                'settings.herold_location',
                'settings.lov_termination_reasons',
                'settings.lov_billing_cycles',
                'settings.original_brands',
                'market_region.view',
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.administration.administration',
            icon: 'clipboard-text-play-outline',
            sidebarItemName: 'administration',
            id: 'administration',
            children: administration,
            permissions: [
                'admin.cronjobs',
                'admin.sanity_checks',
                'queue.monitoring',
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.users.users',
            icon: 'shield-account-outline',
            sidebarItemName: 'user',
            id: 'users',
            children: users,
            permissions: [
                'user.view',
                'role.view'
            ]
        }
    ]
}
